export const LANGUAGE_FONT_MAP: Record<string, string> = {
  "hi-IN": "Noto+Sans+Devanagari",
  "mr-IN": "Noto+Sans+Devanagari",
  "ne-NP": "Noto+Sans+Devanagari",
  "zh-CN": "Noto+Sans+SC",
  "zh-HK": "Noto+Sans+TC",
  "zh-TW": "Noto+Sans+TC",
  "ta-IN": "Noto+Sans+Tamil",
  th: "Noto+Sans+Thai",
  "bn-BD": "Noto+Sans+Bengali",
  "te-IN": "Noto+Sans+Telugu",
  "kn-IN": "Noto+Sans+Kannada",
  "ml-IN": "Noto+Sans+Malayalam",
  gu: "Noto+Sans+Gujarati",
  pa: "Noto+Sans+Gurmukhi",
  "ja-JP": "Noto+Sans+JP",
  "ko-KR": "Noto+Sans+KR",
  ar: "Noto+Sans+Arabic",
  fa: "Noto+Sans+Arabic",
  "fa-AE": "Noto+Sans+Arabic",
  "fa-AF": "Noto+Sans+Arabic",
  "fa-IR": "Noto+Sans+Arabic",
  ur: "Noto+Sans+Arabic",
  "iw-IL": "Noto+Sans+Hebrew",
  "hy-AM": "Noto+Sans+Armenian",
  "ka-GE": "Noto+Sans+Georgian",
  "km-KH": "Noto+Sans+Khmer",
  "lo-LA": "Noto+Sans+Lao",
  "my-MM": "Noto+Sans+Myanmar",
  "si-LK": "Noto+Sans+Sinhala",
  am: "Noto+Sans+Ethiopic",
};
